import { Icon } from '../General/Icon';


export class RemoveIcon extends Icon
{
    constructor()
    {
        super("close", "red");
        this.Class("x-button");
    }
}
